var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "error-404" }, [
      _c("img", {
        staticClass: "error-404-img",
        attrs: { src: "images/err-404.png" },
      }),
      _c("div", { staticClass: "error-404-text" }, [
        _vm._v("Расчет не найден."),
      ]),
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column justify-content-center align-items-center",
        },
        [
          _c(
            "div",
            { staticClass: "error-404-link" },
            [
              _c("router-link", { attrs: { to: "/" } }, [
                _vm._v("Вернуться к списку расчетов"),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "error-404-link mt-2" },
            [
              _c("router-link", { attrs: { to: "/calculation" } }, [
                _vm._v("Создать новый расчет"),
              ]),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }